const CLAIM_TYPES_STATES: any = {
    policyType: (
        name: string,
        answers: { policyType: string },
        value: string,
        clearClaimCategoryStateAction: () => void,
        clearFormTypesStateAction: () => void,
        clearQuestionStateAction: () => void,
        changeAnswerStateAction: (arg0: {
            name: string;
            value: string;
        }) => void,
        history: { replace: (arg0: string) => void },
    ) => {
        if (answers.policyType !== value) {
            clearClaimCategoryStateAction();
            clearFormTypesStateAction();
            clearQuestionStateAction();
            changeAnswerStateAction({
                name: 'claimCategory',
                value: '',
            });
            changeAnswerStateAction({
                name: 'formType',
                value: '',
            });
            history.replace('/claim');
        }
    },
    claimCategory: (
        name: string,
        answers: { claimCategory: string },
        value: string,
        clearClaimCategoryStateAction: any,
        clearFormTypesStateAction: () => void,
        clearQuestionStateAction: () => void,
        changeAnswerStateAction: (arg0: {
            name: string;
            value: string;
        }) => void,
        history: { replace: (arg0: string) => void },
    ) => {
        if (answers.claimCategory !== value) {
            clearFormTypesStateAction();
            clearQuestionStateAction();
            changeAnswerStateAction({
                name: 'formType',
                value: '',
            });
            history.replace('/claim');
        }
    },
    formType: (
        name: string,
        answers: string,
        value: string,
        clearClaimCategoryStateAction: any,
        clearClaimFormTypesStateAction: any,
        clearQuestionStateAction: () => void,
        changeAnswerStateAction: (arg0: {
            name: string;
            value: string;
        }) => void,
        history: { replace: (arg0: string) => void },
    ) => {
        if (!value) {
            clearQuestionStateAction();
            changeAnswerStateAction({
                name: 'formType',
                value: '',
            });
            history.replace('/claim');
        }
    },
};

export default CLAIM_TYPES_STATES;
